import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TemplateHeader from './template-header'
import TemplateEditor from './template-editor'
import { TemplateDTO } from '../dto/template'
import { NONE_MERCHANT, useMerchantContext } from '../context/merchant-context'
import { useCurrentUser } from '../../../contexts/CurrentUserContext'

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
    maxWidth: '100%'
  },
  viewerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
    marginTop: '16px',
    height: '100%',
    maxWidth: '100%'
  }
}))

interface TemplateViewerProps {
  template: TemplateDTO
  gpdTemplate: TemplateDTO
}

const TemplateViewer = ({
  template,
  gpdTemplate
}: TemplateViewerProps): React.ReactElement => {
  const { selectedMerchant } = useMerchantContext()
  const { currentUser } = useCurrentUser()
  const classes = useStyles()

  const isNoneMerchantSelected = selectedMerchant?.id === NONE_MERCHANT?.id
  const isGPDEditAllowed =
    currentUser.hasAccess(['Super Administrator']) && isNoneMerchantSelected
  const isOverrideTemplate = template?.overridenTemplateId
  const isOverrideVisible = !isNoneMerchantSelected && isOverrideTemplate
  const processorDefaultTemplate = isOverrideTemplate ? gpdTemplate : template
  const isMerchantSpecific = template?.merchantSpecific

  return (
    <div className={classes.wrapper}>
      <TemplateHeader template={template} />
      <div className={classes.viewerWrapper}>
        {!isMerchantSpecific && !!processorDefaultTemplate?.templateId && (
          <TemplateEditor
            title="Processor Default"
            key={`processor-default-${processorDefaultTemplate?.templateId}-${processorDefaultTemplate.updatedAt}`} // needed to remount editor
            readonly={!isGPDEditAllowed}
            template={processorDefaultTemplate}
            isFullWidth={!isOverrideVisible}
          />
        )}
        {isOverrideVisible && !!template?.templateId && (
          <TemplateEditor
            title="Override"
            key={`override-${template?.templateId}-${template.updatedAt}`} // needed to remount editor
            template={template}
          />
        )}
        {isMerchantSpecific && !!template?.templateId && (
          <TemplateEditor
            title="Merchant Specific"
            key={`merchant-specific-${template?.templateId}-${template.updatedAt}`} // needed to remount editor
            template={template}
            isFullWidth
          />
        )}
      </div>
    </div>
  )
}

export default TemplateViewer
